//use effect and usestate
import React, { useState, useEffect } from 'react';
import Toast from './../LoadingError/Toast';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {editSupplier, getSupplierById, listSupplier} from '../../Redux/Actions/SupplierActions';









const EditSupplierMain = (props) => {


    const { supplier } = props;

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [country, setCountry] = useState("");




    useEffect(() => {

            if(supplier){
            setName(supplier.name);
            setEmail(supplier.email);
            setPhone(supplier.phone);
            setAddress(supplier.address);
            setCity(supplier.city);
            setPostalCode(supplier.postalCode);
            setCountry(supplier.country);
            }
    }, [supplier]);


    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const supplierUpdated = {
            supplierId: supplier._id,
            name,
            email,
            phone,
            address,
            city,
            postalCode,
            country
        }
           dispatch(editSupplier(supplierUpdated));
    }





    return (
        <>
            <Toast />




            <section className="content-main" style={{ maxWidth: "1200px" }}>
                <form onSubmit={handleSubmit} >

                    <div className="content-header">
                        <Link to="/suppliers" className="btn btn-danger text-white">
                            Go to Suppliers
                        </Link>
                        <h2 className="content-title">Update Supplier</h2>
                        <div>
                            <button type="submit" className="btn btn-primary">
                                Edit Supplier
                            </button>
                        </div>
                    </div>


                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone</label>
                        <input type="text" className="form-control" id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="address">Address</label>
                        <input type="text" className="form-control" id="address" value={address} onChange={(e) => setAddress(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="city">City</label>
                        <input type="text" className="form-control" id="city" value={city} onChange={(e) => setCity(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="postalCode">Postal Code</label>
                        <input type="text" className="form-control" id="postalCode" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="country">Country</label>
                        <input type="text" className="form-control" id="country" value={country} onChange={(e) => setCountry(e.target.value)} />
                    </div>

                </form>
            </section>
        </>
    );
};

export default EditSupplierMain;
